<template lang="pug">
  .height-100
    h3.title Reportes de permisos
    p

    transition-group.contenedor-box(name="fade-smooth-two", tag="div")
      .box(v-if="mostrarListaSolicitudes", key="lista_solicitudes")
        lista-solicitud-permisos(
          @close="mostrarListaSolicitudes = false"
        )
      .box.position-relative(v-if="mostrarListaPermisos", key="lista_permisos")
        lista-permisos(
          @close="mostrarListaPermisos = false"
        )
</template>

<script>
import ListaSolicitudPermisosComponent from './Component_Permisos_Reporte_Solicitud'
import ListaPermisosComponent from './Component_Permisos_Reporte'
export default {
  name: 'permisos-reportes',
  components: {
    'lista-solicitud-permisos' : ListaSolicitudPermisosComponent,
    'lista-permisos'           : ListaPermisosComponent
  },
  props: ['tipo'],
  data () {
    return {
      mostrarListaSolicitudes: false,
      mostrarListaPermisos: false
    }
  },
  watch : {
    tipo (value) {
      return this.rerun()
    }
  },
  created () {
    this.rerun()
  },
  methods: {
    rerun () {
      if (this.tipo === 'solicitud') {
        this.mostrarListaSolicitudes = true
        this.mostrarListaPermisos    = false
      } else if (this.tipo === 'permisos') {
        this.mostrarListaSolicitudes = false
        this.mostrarListaPermisos    = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-box
    display flex
    justify-content center
    flex-direction column
    position relative
    >*
      transition all .5s
      width 100%
</style>



// WEBPACK FOOTER //
// View_Permisos_Reporte.vue?8624ab86